import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SlickDropDownModule, SlickDatePickerModule } from "@slick-components";
import { AutoCoverSpecsComponent } from "./auto-cover-specs.component";
import { AutoCoverSelectComponent } from "./auto-cover-select.component";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		SlickDropDownModule,
		SlickDatePickerModule
	],
	declarations: [
		AutoCoverSpecsComponent,
		AutoCoverSelectComponent
	],
	exports: [
		AutoCoverSpecsComponent
	]
})
export class AutoCoverSpecsModule { }
